export const darkColor = "#94C83D";
export const mainColor = "#1B64B0";
